import airlines from './airlines'

export default {
  flags: {
    brazil: require('src/assets/images/flags/brazil.svg'),
    spain: require('src/assets/images/flags/spain.svg'),
    unitedStates: require('src/assets/images/flags/united-states.svg')
  },
  icons: {
    cipher: require('src/assets/images/icons/cipher.svg'),
    folder: require('src/assets/images/icons/folder.svg'),
    organization: require('src/assets/images/icons/organization.svg'),
    planeGreen: require('src/assets/images/icons/plane-green.png'),
    planeRed: require('src/assets/images/icons/plane-red.png'),
    planeYellow: require('src/assets/images/icons/plane-yellow.png')
  },
  login: {
    bg: require('src/assets/images/bg-login.svg')
  },
  airlines,
  logo: require('src/assets/images/logo.svg'),
  logoIcon: require('src/assets/images/logoIcon.svg'),
  logoName: require('src/assets/images/logoName.svg'),
  logoWhatsSmall: require('src/assets/images/whatsapp.png'),
  vehicle: require('src/assets/images/cars.png'),
  hotels: {
    BLUE_TREE_TOWERS_ANALIA_FRANCO: require('src/assets/images/hotels/BLUE_TREE_TOWERS_ANALIA_FRANCO.png'),
    MERCURE_SAO_PAULO_PAULISTA: require('src/assets/images/hotels/MERCURE_SAO_PAULO_PAULISTA.png')
  },
  noImage: require('src/assets/images/no-image.png'),
  rentalCompanies: {
    alamo: require('src/assets/images/rentalCompanies/alamo.png'),
    localiza: require('src/assets/images/rentalCompanies/localiza.png'),
    movida: require('src/assets/images/rentalCompanies/movida.png'),
    unidas: require('src/assets/images/rentalCompanies/unidas.png')
  }
}
